module.exports = __webpack_public_path__ + "img/code-css-lg.f4ca8c77.webp";